// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Interesses } from "../interfaces/Interesses";

export const cadastrarInteresseService = async (
  usuarioId: number,
  interesseData: Partial<Interesses>
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/interesse/${usuarioId}`;
    try {
      const response = await axios.post(URL, interesseData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
